var _classCallCheck = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/createClass.js");

var TokenAuth = /*#__PURE__*/function () {
  "use strict";

  function TokenAuth(token) {
    _classCallCheck(this, TokenAuth);

    this.token = token;
  }

  _createClass(TokenAuth, [{
    key: "authorize",
    value: function authorize(request) {
      if (!request.headers) request.headers = {};
      request.headers["Authorization"] = "Bearer ".concat(this.token);
    }
  }]);

  return TokenAuth;
}();

module.exports = TokenAuth;